import { useCallback } from 'react';
import { format } from 'date-fns';
import { currencyTransform } from 'utils/numberToCurrencyLocale';
import { useTranslation } from 'react-i18next';
import { useMe } from 'hooks/useMe';
import { obscureText } from 'utils/obscureText';

export const useColumns = () => {
    const { whoami } = useMe();
    const { t } = useTranslation();

    const handleObscureText = useCallback(
        (text) => {
            if (!whoami) {
                return obscureText(text);
            }
            return text;
        },
        [whoami]
    );

    const columns = [
        {
            binding: 'FirstName',
            header: t('firstName'),
            minWidth: 150,
            cellTemplates: [
                {
                    cellType: 'Cell',
                    template: (ctx) => <div>{handleObscureText(ctx.item.FirstName)}</div>
                }
            ],
            isReadOnly: true
        },
        {
            binding: 'LastName',
            header: t('lastName'),
            minWidth: 150,
            cellTemplates: [
                {
                    cellType: 'Cell',
                    template: (ctx) => <div>{handleObscureText(ctx.item.LastName)}</div>
                }
            ],
            isReadOnly: true
        },
        {
            binding: 'FathersName',
            header: t('fathersName'),
            minWidth: 150,
            cellTemplates: [
                {
                    cellType: 'Cell',
                    template: (ctx) => <div>{handleObscureText(ctx.item.FathersName)}</div>
                }
            ],
            isReadOnly: true
        },

        {
            binding: 'UnitPrice',
            header: t('unitPrice'),
            isReadOnly: true,
            minWidth: 150,
            cellTemplates: [
                {
                    cellType: 'Cell',
                    template: (ctx) => <div>{currencyTransform(ctx.item.UnitPrice)}</div>
                }
            ]
        },
        {
            binding: 'SeasonDescription',
            header: t('seasonDescription'),
            isReadOnly: true
        },
        {
            binding: 'CreatedAt',
            header: t('createdAt'),
            format: 'dd/MM/yyyy HH:mm',
            minWidth: 150,
            isReadOnly: true,
            cellTemplates: [
                {
                    cellType: 'Cell',
                    template: (ctx) => <div>{format(new Date(ctx.item.CreatedAt), 'dd/MM/yyyy HH:mm')}</div>
                }
            ]
        }
    ];
    return columns;
};
